import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, isDevMode } from '@angular/core';
import { Observable, ReplaySubject, timer } from 'rxjs';
import { MediaData, StreamPlayItem } from '../types/stream-play.type';
import { StreamPlayIsLiveResponse } from '../types/stream-play-api.type';
import { StreamPlayLiveConfiguration, StreamPlayLiveModule } from './stream-play-live.module';
import { STREAM_PLAY_LIVE_CONFIG_TOKEN } from '../stream-play-tokens';

@Injectable({
  providedIn: StreamPlayLiveModule,
})
export class StreamPlayLiveService {
  private cacheLiveEntryList: { [itemKey: string]: boolean };
  private cacheLiveEntryListObservable: ReplaySubject<{ [itemKey: string]: boolean }>;
  private liveEntryListObservable: { [entryIdMediaType: string]: ReplaySubject<boolean> };

  constructor(
    @Inject(STREAM_PLAY_LIVE_CONFIG_TOKEN) public config: StreamPlayLiveConfiguration,
    private httpClient: HttpClient) {

    this.cacheLiveEntryList = {};
    this.cacheLiveEntryListObservable = new ReplaySubject<{ [p: string]: boolean }>(1);
    this.liveEntryListObservable = {};
  }

  public getLiveEntryList(): Observable<{ [itemKey: string]: boolean }> {

    return this.cacheLiveEntryListObservable.asObservable();

  }

  public getLiveEntry(itemKey: string): Observable<boolean> {

    return this.liveEntryListObservable[itemKey].asObservable();
  }

  public entryLiveApiCall(spItem: StreamPlayItem, entryMediaData: MediaData, forceCall?: boolean, noPool?: boolean): void {
    const itemKey = `${spItem.id}-${entryMediaData.entryId}-${entryMediaData.mediaType}`;

    if (!entryMediaData?.isLiveUrl || (this.cacheLiveEntryList[itemKey] !== undefined && !forceCall)) {

      return;
    }

    if (this.liveEntryListObservable[itemKey] === undefined) {
      this.liveEntryListObservable[itemKey] = new ReplaySubject<boolean>(1);
    }

    this.httpClient.get<StreamPlayIsLiveResponse>(entryMediaData.isLiveUrl).subscribe((data) => {

      if (data) {

        let startDateOk = true;
        if (this.config.checkStartDate && spItem.startDate) {
          startDateOk = new Date() >= new Date(new Date(spItem.startDate).getTime() - (this.config.offset ? (this.config.offset * 60000): 0));
        }

        let endDateOk = true;
        if (this.config.checkEndDate && spItem.endDate) {
          endDateOk = new Date() <= new Date(spItem.endDate);
        }

        const isLive = data.isLive && startDateOk && endDateOk;
        this.cacheLiveEntryList[itemKey] = isLive;

        this.liveEntryListObservable[itemKey].next(isLive);
        this.cacheLiveEntryListObservable.next(this.cacheLiveEntryList);

        if (isDevMode()) {
          const isLiveString = data.isLive ? 'live': 'not live';
          const pollingDurationInSeconds = data.pollingFrequency * 1000;

          console.log(
            `Polling success. '${itemKey}' is currently ${isLiveString}, and will poll in ${pollingDurationInSeconds} seconds.`,
          );
        }

        if (data.pollingFrequency && !noPool) {
          timer(data.pollingFrequency * 1000).subscribe(() => {
            this.entryLiveApiCall(spItem, entryMediaData, true);
          });
        }
      }
    });
  }
}
